import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id B8B83A21-D267-47BD-868F-BECB081CEC1C
 * name spear
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/spear.svg
 * tags
 * - Gaming / RPG 
 */
export const SpearIcon = createSvgIcon(<><path d="M16 9H16.41L3.41 22L2 20.59L15 7.59V9H16M16 4V8H20L22 2L16 4Z" /></>, 'SpearIcon');
export default SpearIcon